import { gql } from 'glimmer-apollo';

export const SEARCH_QUERY = gql`
  query SearchContent($query: String!, $limit: Int) {
    search(query: $query, limit: $limit) {
      results {
        ... on ESportsArticle {
          __typename
          id
          title
          shortDescription
          slug
          publishedDate
          coverImage {
            url
            title
            description
          }
          author {
            name
            avatar {
              url
            }
          }
        }
        ... on GameArticle {
          __typename
          id
          title
          shortDescription
          slug
          publishedDate
          coverImage {
            url
            title
            description
          }
          author {
            name
            avatar {
              url
            }
          }
        }
        ... on Team {
          __typename
          id
          name
          slug
          bioBlurb
          country
          region
          logo {
            url
            title
            description
          }
          game {
            id
            name
            image {
              url
            }
          }
          players {
            id
            gamertag
            slug
          }
        }
        ... on Player {
          __typename
          id
          gamertag
          irlName
          slug
          country
          role
          photo {
            url
            title
            description
          }
          currentTeam {
            id
            name
            slug
            logo {
              url
            }
          }
        }
        ... on Tournament {
          __typename
          id
          title
          slug
          startDate
          endDate
          prizePool
          format
          image {
            url
          }
          game {
            id
            name
            image {
              url
              title
              description
            }
          }
        }
        ... on Match {
          __typename
          id
          title
          slug
          format
          game {
            id
            name
            image {
              url
              title
              description
            }
          }
          teams {
            id
            name
            slug
            logo {
              url
              title
              description
            }
          }
        }
      }
    }
  }
`;

export const SEARCH_SUGGESTIONS_QUERY = gql`
  query SearchSuggestions($query: String!, $limit: Int) {
    searchSuggestions(query: $query, limit: $limit) {
      text
      type
      count
    }
  }
`;